export default {


    flexParentId: 'blocks-flexparent-'+Math.random().toString(36).substr(2, 16),
    parentBackground: '#e5e5e5',

    parentHorizontalPadding: 20,
    parentVerticalPadding: 20,
    horizontalPadTabletParent: null,
    verticalPadTabletParent: null,
    horizontalPadPhoneParent: null,
    verticalPadPhoneParent: null,

    parentMaxWidth: 1000,
    parentFullWidth: false,

    useBorderParent: false,
    useIndividualBorder: false,

    useIndividualBorderRadius: false,

    borderRadiusGeneral: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,


    parentBorderWidth: 1,
    parentBorderType: 'solid',
    parentBorderColor: '#ccc',

    parentBorderWidthTablet: 0,
    parentBorderWidthPhone: 0,

    borderTopColorParent: '#cccccc',
    borderTopStyleParent: 'solid',
    borderTopWidthParent: 1,

    borderRightColorParent: '#cccccc',
    borderRightStyleParent: 'solid',
    borderRightWidthParent: 1,
    
    borderBottomColorParent: '#cccccc',
    borderBottomStyleParent: 'solid',
    borderBottomWidthParent: 1,
    
    borderLeftColorParent: '#cccccc',
    borderLeftStyleParent: 'solid',
    borderLeftWidthParent: 1,

    borderGeneralWidthTabletParent: null,
    borderTopWidthTabletParent: null,
    borderRightWidthTabletParent: null,
    borderBottomWidthTabletParent: null,
    borderLeftWidthTabletParent: null,

    borderGeneralWidthPhoneParent: null,
    borderTopWidthPhoneParent: null,
    borderRightWidthPhoneParent: null,
    borderBottomWidthPhoneParent: null,
    borderLeftWidthPhoneParent: null,

    backgroundColor: true,
    backgroundImage: false,
    backgroundImageSet: 'https://appjustable.com/weebly/app_in_process/dummy-content/preview-dummy-image-app.jpg',
    backgroundVideo: false,
    backgroundVideoUrl: 'https://www.youtube.com/watch?v=-SJXOTtdTDE&list=PLx-qGAzjv13c00FYZMLAJm65WjsT3ZmDR&index=3',
    parentVideoStartTime : 0,
    xAxisPosition: 'center',
    yAxisPosition: 'center',
    useParallax: false,
    parallaxSpeed: 0.2,


    childBlocks: [
        {
            blockId: 'blocks-flexchild-'+Math.random().toString(36).substr(2, 16),
            childBackground: '#f1f1f1',
            maxWidthDesktop: '100',
            maxWidthTablet: null,
            maxWidthPhone: null,
            hideOnDesktop: false,
            hideOnTablet: false,
            hideOnPhone: false,
            horizontalPad: 15,
            verticalPad: 15,
            horizontalPadTablet: null,
            verticalPadTablet: null,
            horizontalPadPhone: null,
            verticalPadPhone: null,

            borderGeneralColor: '#cccccc',
            borderGeneralStyle: 'solid',
            borderGeneralWidth: 1,

            useIndividualBorder: false,

            borderTopColor: '#cccccc',
            borderTopStyle: 'solid',
            borderTopWidth: 1,
            
            borderRightColor: '#cccccc',
            borderRightStyle: 'solid',
            borderRightWidth: 1,
            
            borderBottomColor: '#cccccc',
            borderBottomStyle: 'solid',
            borderBottomWidth: 1,
            
            borderLeftColor: '#cccccc',
            borderLeftStyle: 'solid',
            borderLeftWidth: 1,

            borderGeneralWidthTablet: null,
            borderTopWidthTablet: null,
            borderRightWidthTablet: null,
            borderBottomWidthTablet: null,
            borderLeftWidthTablet: null,

            borderGeneralWidthPhone: null,
            borderTopWidthPhone: null,
            borderRightWidthPhone: null,
            borderBottomWidthPhone: null,
            borderLeftWidthPhone: null,

            useIndividualBorderRadius: false,

            borderRadiusGeneral: 0,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0,

            backgroundColorChild: true,
            backgroundImageChild: false,
            backgroundVideoChild: false,
            backgroundVideoUrl: 'https://www.youtube.com/watch?v=-SJXOTtdTDE&list=PLx-qGAzjv13c00FYZMLAJm65WjsT3ZmDR&index=3',
            backgroundImageChildSet: 'https://appjustable.com/weebly/app_in_process/dummy-content/preview-dummy-image-app.jpg',

            childVideoStartTime : 0,

            xAxisPosition: 'center',
            yAxisPosition: 'center',
            useParallax: false,
            parallaxSpeed: 0.2,

            useLink: false,
            link: 'https://www.waddons.com',
            target: '_blank'

        }
    ]

}


// WEBPACK FOOTER //
// ./src/store/elementSettings/blockssettings.js